import { MdCheck, MdClose } from "react-icons/md";
import {
  API_ENDPOINT_UPDATE_PROFILE,
  ICON_SIZES,
} from "../../helpers/constants";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import Modal from "../Modal/Modal";
import ModalFooter from "../Modal/ModalFooter";
import TextInput from "../TextInput/TextInput";
import { useMemo, useState } from "react";
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";
import { showNotification } from "src/helpers/utils";
import apiClient from "../../helpers/api-client";
import { EButtonKind } from "../Button/ButtonTypes";

interface IChangePasswordModal {
  onClose: () => void;
}

const ChangePasswordModal: React.FC<IChangePasswordModal> = ({ onClose }) => {
  const [newPassword, setNewPassword] = useState<string>("");
  const [confirmNewPassword, setConfirmNewPassword] = useState<string>("");
  const [currentPassword, setCurrentPassword] = useState<string>("");

  const [isUpdatingPassword, setIsUpdatingPassword] = useState<boolean>(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState<boolean>(false);

  const { t } = useTranslation();

  const updatePassword = () => {
    setIsUpdatingPassword(true);

    const formData = new FormData();

    formData.append("password", newPassword?.trim?.());

    apiClient
      .put(API_ENDPOINT_UPDATE_PROFILE, formData, {
        // headers: { "Content-Type": "multipart/form-data" },
      })
      .then(async (res: any) => {
        showNotification({
          kind: "success",

          message: "Contraseña actualizada correctamente",
        });
        setNewPassword("");
        setShowConfirmDialog(false);
      })
      .catch((e: any) => {
        showNotification({
          message: "Error actualizando tu contraseña",
          kind: "error",
        });
      })
      .finally(() => {
        setIsUpdatingPassword(false);
      });
  };

  const canChangePassword = useMemo(() => {
    return (
      currentPassword &&
      newPassword &&
      confirmNewPassword &&
      newPassword === confirmNewPassword
    );
  }, [currentPassword, newPassword, confirmNewPassword]);

  return (
    <>
      <Modal
        onEscape={() => onClose()}
        className={clsx("md:!max-w-[400px]", "md:!w-full")}
      >
        <Modal.Header
          title={t("Cambiar contraseña de acceso")}
          onClose={() => onClose()}
        />
        <Modal.Body>
          <div className={clsx(["flex", "flex-col", "gap-6", "w-full"])}>
            <TextInput
              value={currentPassword}
              onChange={(e: any) => setCurrentPassword(e?.target?.value)}
              label={t("Contraseña actual")}
              placeholder={t(
                "change_password_page.current_password_placeholder"
              )}
              type="password"
              required
            />
            <TextInput
              value={newPassword}
              onChange={(e: any) => setNewPassword(e?.target?.value)}
              label={t("change_password_page.new_password_label")}
              placeholder={t("change_password_page.new_password_placeholder")}
              type="password"
              required
            />
            <TextInput
              value={confirmNewPassword}
              onChange={(e: any) => setConfirmNewPassword(e?.target?.value)}
              label={t("Confirma la contraseña")}
              placeholder={t(
                "change_password_page.confirm_password_placeholder"
              )}
              type="password"
              required
            />
          </div>
        </Modal.Body>
        <ModalFooter
          actions={[
            {
              text: t("common_buttons.update"),
              onClick: () => {},
              icon: <MdCheck size={32} />,
              kind: EButtonKind.SAVE,
              isLoading: isUpdatingPassword,
              disabled: isUpdatingPassword || !canChangePassword,
            },
            {
              text: t("common_buttons.close"),
              icon: <MdClose size={ICON_SIZES.MD} />,
              onClick: () => onClose(),
              kind: EButtonKind.NORMAL,
            },
          ]}
        />
      </Modal>
      {showConfirmDialog && (
        <ConfirmDialog
          title={t("Cambiar contraseña")}
          description={t("¿Deseas cambiar tu contraseña de acceso?")}
          onClose={() => {
            setShowConfirmDialog(false);
          }}
          confirmKind={EButtonKind.SAVE}
          onConfirm={() => {
            updatePassword();
          }}
          isLoading={isUpdatingPassword}
        />
      )}
    </>
  );
};

export default ChangePasswordModal;
